import React, { useContext } from 'react';
import { IModifiersContext, ModifiersContext } from '../../../../../modifiersState/modifiersContext';
import Text from 'components/Text/Text';
import style from './DropdownMenu.module.scss';

export const DropdownMenu: React.FC = () => {
	const { setSortBy, sortBy } = useContext<IModifiersContext>(ModifiersContext);

	return (
		<div className={style.container} data-test="DropdownMenu">
			<div className={style.resetWrapper}>
				<span className={style.resetBtn} onClick={() => setSortBy('')}>
					<Text translationNameSpace="listing" translationKey="resetButton" asFragment={true} />
				</span>
			</div>

			<div className={style.item}>
				<div className={style.headingWrapper}>
					<Text
						translationNameSpace="listing"
						translationKey="sortByModifierLabel"
						theme="neutralLight"
						size="s"
					/>
				</div>
				<label className={style.sortingControl}>
					<Text translationNameSpace="listing" translationKey="sortByModifierA-Z" size="s" />
					<input
						type="radio"
						className={style.radioBtn}
						onChange={() => setSortBy('ModifiersA-Z')}
						checked={sortBy === 'ModifiersA-Z'}
						name="assignmentSort"
					/>
				</label>
				<label className={style.sortingControl}>
					<Text translationNameSpace="listing" translationKey="sortByModifierZ-A" size="s" />
					<input
						type="radio"
						className={style.radioBtn}
						onChange={() => setSortBy('ModifiersZ-A')}
						checked={sortBy === 'ModifiersZ-A'}
						name="assignmentSort"
					/>
				</label>
			</div>
		</div>
	);
};
